import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { AppsService } from "src/app/shared/services/apps.service";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import moment from "moment";
import { differenceInCalendarDays } from "date-fns";

@Component({
  selector: "app-state-level-vehicle-dashboard",
  templateUrl: "./state-level-vehicle-dashboard.component.html",
  styleUrls: ["./state-level-vehicle-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StateLevelVehicleDashboardComponent implements OnInit {
  /** Restored from <dxo-summary>, dropped by the bulk conversion. */
  gridTotals0: any[] = [
    { column: "tnt_nm", summaryType: "count", displayFormat: "Total: {0}" },
    { column: "ttl_vhcls", summaryType: "sum", displayFormat: "{0}" },
    { column: "dist_vhcl_ttl", summaryType: "sum", displayFormat: "{0}" },
    { column: "dist_operated", summaryType: "sum", displayFormat: "{0}" },
    { column: "dist_not_operated", summaryType: "sum", displayFormat: "{0}" },
    { column: "wh_vhcl_ttl", summaryType: "sum", displayFormat: "{0}" },
    { column: "wh_operated", summaryType: "sum", displayFormat: "{0}" },
    { column: "wh_not_operated", summaryType: "sum", displayFormat: "{0}" },
    { column: "primary_ttl", summaryType: "sum", displayFormat: "{0}" },
    { column: "primary_dist_ttl", summaryType: "sum", displayFormat: "{0}" },
    {
      column: "primary_dist_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    {
      column: "primary_dist_not_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    { column: "primary_wh_ttl", summaryType: "sum", displayFormat: "{0}" },
    { column: "primary_wh_operated", summaryType: "sum", displayFormat: "{0}" },
    {
      column: "primary_wh_not_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    { column: "secondary_ttl", summaryType: "sum", displayFormat: "{0}" },
    { column: "secondary_dist_ttl", summaryType: "sum", displayFormat: "{0}" },
    {
      column: "secondary_dist_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    {
      column: "secondary_dist_not_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    { column: "secondary_wh_ttl", summaryType: "sum", displayFormat: "{0}" },
    {
      column: "secondary_wh_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    {
      column: "secondary_wh_not_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
    { column: "own_ct", summaryType: "sum", displayFormat: "{0}" },
    { column: "contract_ct", summaryType: "sum", displayFormat: "{0}" },
    { column: "sac_ct", summaryType: "sum", displayFormat: "{0}" },
    { column: "dist_abv_500m", summaryType: "sum", displayFormat: "{0}" },
    { column: "dist_blw_500m", summaryType: "sum", displayFormat: "{0}" },
    { column: "wh_abv", summaryType: "sum", displayFormat: "{0}" },
    { column: "wh_blw", summaryType: "sum", displayFormat: "{0}" },
    { column: "cdma_total", summaryType: "sum", displayFormat: "{0}" },
    { column: "cdma_operated", summaryType: "sum", displayFormat: "{0}" },
    { column: "cdma_not_operated", summaryType: "sum", displayFormat: "{0}" },
    { column: "ulb_dev_total", summaryType: "sum", displayFormat: "{0}" },
    { column: "ulb_dev_operated", summaryType: "sum", displayFormat: "{0}" },
    {
      column: "ulb_dev_not_operated",
      summaryType: "sum",
      displayFormat: "{0}",
    },
  ];
  /** Restored from <dxo-summary>, dropped by the bulk conversion. */
  gridTotals2: any[] = [
    { column: "tnt_nm", summaryType: "count", displayFormat: "Total: {0}" },
    { column: "total_drivers", summaryType: "sum", displayFormat: "{0}" },
    { column: "own", summaryType: "sum", displayFormat: "{0}" },
    { column: "own_attended", summaryType: "sum", displayFormat: "{0}" },
    { column: "own_not_attended", summaryType: "sum", displayFormat: "{0}" },
    { column: "apcos", summaryType: "sum", displayFormat: "{0}" },
    { column: "apcos_attended", summaryType: "sum", displayFormat: "{0}" },
    { column: "apcos_not_attended", summaryType: "sum", displayFormat: "{0}" },
    { column: "contract", summaryType: "sum", displayFormat: "{0}" },
    { column: "contract_attended", summaryType: "sum", displayFormat: "{0}" },
    {
      column: "contract_not_attended",
      summaryType: "sum",
      displayFormat: "{0}",
    },
  ];

  header_label = {
    name: "State Vehicle Dashboard",
  };

  showLdr = false;
  slctdDt: any;
  curDate: any;
  dateFormat = "dd-MM-yyyy";
  clntDtls: any;
  tntLst: any = [];
  userDtls: any;
  clap_in: number;

  fromUrbanDashboard: boolean = false;
  drawerWidth: string =
    window.innerWidth <= 640
      ? "100%"
      : window.innerWidth <= 1024
      ? "90%"
      : "80%";

  // Card 1: Vehicles Overview
  tdyCoveredTrips: any = [];
  overallOwnerCounts: any = { own: 0, contract: 0, sac: 0 };
  primaryOwnerCounts: any = { own: 0, contract: 0, sac: 0 };
  secondaryOwnerCounts: any = { own: 0, contract: 0, sac: 0 };

  // Card 2: Distance & Working Hours
  ttlDstncCnt: any = [];

  // Card 3: VMU Maintained
  vmuMaintainedData: any = {
    cdma: { total: 0, operated: 0, notOperated: 0, operatedPercent: 0 },
    ulb: { total: 0, operated: 0, notOperated: 0, operatedPercent: 0 },
  };

  // Card 4: Driver Type
  driverTypeCounts: any = {
    total: 0,
    own: 0,
    apcos: 0,
    contract: 0,
    own_attended: 0,
    own_not_attended: 0,
    apcos_attended: 0,
    apcos_not_attended: 0,
    contract_attended: 0,
    contract_not_attended: 0,
  };

  // ULB-wise Vehicle Table
  ulbVehicleData: any = [];
  vehicleTableLdr: boolean = false;
  selectedVehType: string = "all";

  // ULB-wise Driver Table
  ulbDriverData: any = [];
  driverTableLdr: boolean = false;

  // Vehicle detail view (tab-style: ULB list → detail → go back)
  selectedVehicleUlb: any = null;
  vehicleDetailList: any = [];
  vehicleDetailLdr: boolean = false;

  // Driver detail view (tab-style: ULB list → detail → go back)
  selectedDriverUlb: any = null;
  driverDetailList: any = [];
  driverDetailLdr: boolean = false;

  // Slider drawers
  vhclSldrVisible: boolean = false;
  selectedVehicleForSlider: any = null;
  driverSldrVisible: boolean = false;
  selectedDriverForSlider: any = null;

  disabledDate = (current: Date): boolean => {
    return differenceInCalendarDays(current, new Date()) > 0;
  };

  constructor(
    public apiServ: AppsService,
    private router: Router,
    public TransfereService: TransfereService
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    this.clap_in = this.userDtls.clap_in;
  }

  ngOnInit() {
    this.fromUrbanDashboard =
      this.TransfereService.getLoclData("from_urban_dashboard") === true;
    this.TransfereService.setLoclData("from_urban_dashboard", false);
    this.slctdDt = new Date();
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.loadAllData();
  }

  onChange(result: Date): void {
    this.curDate = moment(result).format("YYYY-MM-DD");
    this.selectedVehicleUlb = null;
    this.selectedDriverUlb = null;
    this.loadAllData();
  }

  loadAllData() {
    this.getUlbTdyCount();
    this.getTotalDistance();
    this.getVmuMaintainedData();
    this.getDriverTypeCounts();
    this.getUlbWiseVehicleData();
    this.getUlbWiseDriverData();
  }

  // --- Card APIs (reuse existing state-level endpoints) ---

  getUlbTdyCount() {
    this.tdyCoveredTrips = [];
    this.showLdr = true;
    let postData = { dt: this.curDate, slctd_tnt: 0 };
    this.apiServ.post(postData, `dashboard/enterprise/ulb_tdy/state`).subscribe(
      (res) => {
        if (res["status"] == 200 && res["data"] && res["data"].length > 0) {
          this.tdyCoveredTrips = res["data"];
          const d = res["data"][0];
          // Set owner counts from ulb_tdy response
          this.overallOwnerCounts = {
            own: d.own_ct || 0,
            contract: d.contract_ct || 0,
            sac: d.sac_ct || 0,
          };
          this.primaryOwnerCounts = {
            own: d.primary_own || 0,
            contract: d.primary_contract || 0,
            sac: d.primary_sac || 0,
          };
          this.secondaryOwnerCounts = {
            own: d.secondary_own || 0,
            contract: d.secondary_contract || 0,
            sac: d.secondary_sac || 0,
          };
        }
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
        this.showLdr = false;
      }
    );
  }

  getTotalDistance() {
    this.ttlDstncCnt = [];
    let postData = { dt: this.curDate, slctd_tnt: 0 };
    this.apiServ
      .post(postData, `dashboard/enterprise/get_ttlDstnce/state`)
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"] && res["data"].length > 0) {
            this.ttlDstncCnt = res["data"];
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getVmuMaintainedData() {
    let postData = { dt: this.curDate, slctd_tnt: 0 };
    this.apiServ
      .post(postData, `dashboard/enterprise/get_vmu_maintained_data/state`)
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              const cdmaTotal = data.cdma_total || 0;
              const cdmaOperated = data.cdma_operated || 0;
              const ulbTotal = data.ulb_total || 0;
              const ulbOperated = data.ulb_operated || 0;
              this.vmuMaintainedData = {
                cdma: {
                  total: cdmaTotal,
                  operated: cdmaOperated,
                  notOperated: data.cdma_not_operated || 0,
                  operatedPercent:
                    cdmaTotal > 0
                      ? Math.round((cdmaOperated / cdmaTotal) * 1000) / 10
                      : 0,
                },
                ulb: {
                  total: ulbTotal,
                  operated: ulbOperated,
                  notOperated: data.ulb_not_operated || 0,
                  operatedPercent:
                    ulbTotal > 0
                      ? Math.round((ulbOperated / ulbTotal) * 1000) / 10
                      : 0,
                },
              };
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getDriverTypeCounts() {
    let postData = { slctd_tnt: 0, dt: this.curDate };
    this.apiServ
      .post(postData, `dashboard/enterprise/get_driver_type_counts/state`)
      .subscribe(
        (res) => {
          if (res["status"] == 200 && res["data"]) {
            const data = Array.isArray(res["data"])
              ? res["data"][0]
              : res["data"];
            if (data) {
              this.driverTypeCounts = {
                total: data.total || data.total_count || 0,
                own: data.own || data.own_count || 0,
                apcos: data.apcos || data.apcos_count || 0,
                contract: data.contract || data.contract_count || 0,
                own_attended: data.own_attended || 0,
                own_not_attended: data.own_not_attended || 0,
                apcos_attended: data.apcos_attended || 0,
                apcos_not_attended: data.apcos_not_attended || 0,
                contract_attended: data.contract_attended || 0,
                contract_not_attended: data.contract_not_attended || 0,
              };
              if (!this.driverTypeCounts.total) {
                this.driverTypeCounts.total =
                  this.driverTypeCounts.own +
                  this.driverTypeCounts.apcos +
                  this.driverTypeCounts.contract;
              }
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  // --- ULB-Wise Table APIs ---

  getUlbWiseVehicleData() {
    this.ulbVehicleData = [];
    this.vehicleTableLdr = true;
    let postData: any = { dt: this.curDate, veh_type: this.selectedVehType };
    this.apiServ
      .post(postData, `dashboard/enterprise/ulbWiseVehicleData/state`)
      .subscribe(
        (res) => {
          if (res["data"]) {
            this.ulbVehicleData = (res["data"] || []).map((row, idx) => ({
              ...row,
              sno: idx + 1,
            }));
          }
          this.vehicleTableLdr = false;
        },
        (err) => {
          console.log(err);
          this.vehicleTableLdr = false;
        }
      );
  }

  getUlbWiseDriverData() {
    this.ulbDriverData = [];
    this.driverTableLdr = true;
    let postData: any = { dt: this.curDate };
    this.apiServ
      .post(postData, `dashboard/enterprise/ulbWiseDriverData/state`)
      .subscribe(
        (res) => {
          if (res["data"]) {
            this.ulbDriverData = (res["data"] || []).map((row, idx) => ({
              ...row,
              sno: idx + 1,
            }));
          }
          this.driverTableLdr = false;
        },
        (err) => {
          console.log(err);
          this.driverTableLdr = false;
        }
      );
  }

  // --- Vehicle Detail (tab-style: click ULB → detail view) ---

  onVehicleUlbClick(row: any) {
    // Close driver detail if open
    if (this.selectedDriverUlb) {
      this.selectedDriverUlb = null;
      this.driverDetailList = [];
    }
    this.selectedVehicleUlb = row;
    this.vehicleDetailList = [];
    this.vehicleDetailLdr = true;
    let postData: any = {
      dt: this.curDate,
      tnt_id: row.tnt_id,
      veh_type: this.selectedVehType,
    };
    this.apiServ
      .post(postData, `dashboard/enterprise/vehicleWiseDetail/state`)
      .subscribe(
        (res) => {
          if (res["data"]) {
            this.vehicleDetailList = (res["data"] || []).map((r, idx) => ({
              ...r,
              sno: idx + 1,
              wrkd_tm_fmt: this.formatWorkingTime(r.wrkd_sec),
            }));
          }
          this.vehicleDetailLdr = false;
        },
        (err) => {
          console.log(err);
          this.vehicleDetailLdr = false;
        }
      );
  }

  goBackToVehicleUlbs() {
    this.selectedVehicleUlb = null;
    this.vehicleDetailList = [];
  }

  // --- Driver Detail (tab-style: click ULB → detail view) ---

  onDriverUlbClick(row: any) {
    // Close vehicle detail if open
    if (this.selectedVehicleUlb) {
      this.selectedVehicleUlb = null;
      this.vehicleDetailList = [];
    }
    this.selectedDriverUlb = row;
    this.driverDetailList = [];
    this.driverDetailLdr = true;
    let postData: any = { dt: this.curDate, tnt_id: row.tnt_id };
    this.apiServ
      .post(postData, `dashboard/enterprise/driverWiseDetail/state`)
      .subscribe(
        (res) => {
          if (res["data"]) {
            this.driverDetailList = (res["data"] || []).map((r, idx) => ({
              ...r,
              sno: idx + 1,
            }));
          }
          this.driverDetailLdr = false;
        },
        (err) => {
          console.log(err);
          this.driverDetailLdr = false;
        }
      );
  }

  goBackToDriverUlbs() {
    this.selectedDriverUlb = null;
    this.driverDetailList = [];
  }

  // --- Slider Handlers ---

  onVehicleNameClick(row: any) {
    this.router.navigate(["/internal/dashboard/vehicle-dashboard"], {
      queryParams: {
        asrt_id: JSON.stringify(row.asrt_id),
      },
    });
  }

  onDriverNameClick(row: any) {
    this.selectedDriverForSlider = row;
    this.driverSldrVisible = true;
  }

  formatWorkingTime(seconds: number): string {
    if (!seconds || seconds <= 0) return "0h 0m";
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${hrs}h ${mins}m`;
  }

  // --- Card Click Handlers ---

  onVehicleCardClick() {
    if (this.selectedVehicleUlb) {
      this.selectedVehicleUlb = null;
      this.vehicleDetailList = [];
    }
    this.scrollToElement("vehicleTableSection");
  }

  onDriverCardClick() {
    if (this.selectedDriverUlb) {
      this.selectedDriverUlb = null;
      this.driverDetailList = [];
    }
    this.scrollToElement("driverTableSection");
  }

  onVehTypeClick(type: string) {
    if (this.selectedVehType === type) {
      this.selectedVehType = "all";
    } else {
      this.selectedVehType = type;
    }
    this.selectedVehicleUlb = null;
    this.vehicleDetailList = [];
    this.getUlbWiseVehicleData();
    this.scrollToElement("vehicleTableSection");
  }

  // --- Navigation ---

  goBackToDashboard() {
    this.router.navigate([`internal/dashboard/urban-dashboard`]);
  }

  navigateTo(page: string) {
    this.router.navigate([`internal/dashboard/${page}`]);
  }

  scrollToElement(id: string) {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 400);
  }
}
